var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnPlayYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 126,
    width: 35,
    height: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_1",
    x: -150,
    y: -126,
    width: 335,
    height: 335,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 24,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_de_desplazamiento_27",
    "data-name": "Grupo de desplazamiento 27",
    transform: "translate(-150 -126)",
    clipPath: "url(#clip-path)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(149.947 126.152)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.05, -0.15)",
    filter: "url(#Ellipse_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1-2",
    "data-name": "Ellipse 1",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(0 0)",
    fill: "#f5f5fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(11.661 10.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,12.967V.672A.671.671,0,0,1,1.033.107l9.61,6.147a.671.671,0,0,1,0,1.131l-9.61,6.147A.671.671,0,0,1,0,12.967Z",
    transform: "translate(0.261 0.256)",
    fill: "#f1be14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.521,13.224V.906a.394.394,0,0,1,0-.045c0,.055,0,.009,0-.007C.534.823.543.792.552.763.534.815.547.771.555.758S.578.716.592.7.607.673.614.663C.583.706.6.676.612.668.637.643.659.621.685.6c-.042.036-.01.007,0,0L.732.571.768.552C.818.524.73.562.78.547.813.538.844.528.877.521c.059-.016-.035-.005,0,0a.486.486,0,0,0,.05,0,.333.333,0,0,1,.042,0s.067.012.028,0l.028.007a.619.619,0,0,1,.061.019c.045.014.009,0,0,0l.059.031L1.162.59l.005,0L1.242.64l.387.247,1.512.967L5.271,3.217Q6.4,3.939,7.53,4.662L9.474,5.905q.579.371,1.159.74c.038.024.074.048.112.071l.026.016,0,0,.038.026c-.04-.031,0,0,.007.009s.035.036.052.054.021.038,0,0c.007.012.016.022.022.035s.019.036.029.055.012.043,0-.005c.01.033.021.064.029.1a.319.319,0,0,1,.007.04c-.01-.066,0,0,0,.012s-.009.121,0,.052a.627.627,0,0,1-.022.1.247.247,0,0,1-.014.038c.017-.054.005-.01,0,0a.381.381,0,0,1-.026.045c-.005.007-.045.062-.009.016a1.046,1.046,0,0,1-.074.078c-.007.007-.038.031,0,0l-.038.026,0,0-.022.014-.882.564L8.081,9.131,5.847,10.56l-2.2,1.406q-.859.55-1.718,1.1c-.256.164-.51.33-.768.491-.028.017-.055.033-.085.048.043-.022.012-.005,0,0l-.052.016c-.017.005-.035.007-.052.012.047-.014.026,0,.007,0a1,1,0,0,1-.1,0c-.048,0,0,0,.009,0-.019,0-.04-.007-.059-.012S.74,13.587.768,13.6s-.045-.024-.059-.033-.028-.021-.042-.028c-.033-.016.04.04,0,0-.024-.024-.048-.047-.071-.073.036.04-.007-.012-.019-.029S.555,13.4.545,13.38s-.01-.042,0,.005c-.009-.035-.021-.067-.029-.1,0-.014,0-.047,0,0a.237.237,0,0,0,0-.062.262.262,0,0,0-.259-.259A.265.265,0,0,0,0,13.224a.932.932,0,0,0,1.425.789c.064-.04.128-.081.19-.123l1.261-.806,2.029-1.3,2.3-1.472L9.3,8.974q.706-.451,1.413-.9l.3-.189a1.008,1.008,0,0,0,.251-.218.944.944,0,0,0,.114-.995,1.115,1.115,0,0,0-.445-.446l-.417-.266L8.936,4.944l-2.181-1.4L4.463,2.083,2.548.858,1.5.189A1.008,1.008,0,0,0,.718.023.947.947,0,0,0,0,.96V13.227a.262.262,0,0,0,.259.259A.271.271,0,0,0,.521,13.224Z",
    transform: "translate(0 0)",
    fill: "#f1be14"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlayYellow);
export default __webpack_public_path__ + "static/media/btn-play-yellow.c183a1b1.svg";
export { ForwardRef as ReactComponent };